import { Button } from "@mui/material";
import { useFormikContext } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import { TagEnum } from "../../../Enumeration/TagEnum";
import { TagValueEnum } from "../../../Enumeration/TagValueEnum";
import { OK, VIEW_MODE } from "../../../Utils/GlobalValues";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplDragDrop from "../../CsplControls/CsplDragDrop/CsplDragDrop";
import CsplLabel from "../../CsplControls/CsplLabel/CsplLabel";
import CsplBackDropLoading from "../../CsplControls/CsplLoader/CsplBackDropLoading";
import CsplNumberField from "../../CsplControls/CsplNumber/CsplNumber";
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import PercentageComponent from "../../CsplControls/PercentageComponent/PercentageComponent";
import AlertModal from "../../CsplModal/AlertModal";
import BankVerificationResource from "../../Resources/BankVerificationResource/BankVerificationResource";
import TagValueResource from "../../Resources/CommonResources/TagValueResource";

import useStaticData from "../../CsplControls/CsplAch/UseStaticData";
import styles from "./BankAccountDetails.module.css";

function BankAccountDetails(props) {
  const { t } = useTranslation("common");
  const { values, setFieldValue } = useFormikContext();
  const applicationContext = useContext(KycApplicationContext);
  let [isDisabled, setIsDisabled] = useState(applicationContext.disableForm);
  let [isFormDisabled, setIsFormDisabled] = useState(
    applicationContext.disableForm,
  );
  let formMode = applicationContext.mode;
  const [bankID, setBankId] = useState("");
  const [showIfscLookup, setShowIfscLookup] = useState(false);
  const [
    performNonFinancialTransaction,
    performFinancialTransaction,
    validateBankVerification,
  ] = BankVerificationResource();
  const [mismatchPercentage, setMismatchPercentage] = useState(0);

  const [isLookupProcessing, getLookupData] = useStaticData();

  const [getTagValue] = TagValueResource();
  const [transferAmountRequired, setTransferAmountRequired] = useState(false);
  const [clickVerifyBank, setClickVerifyBank] = useState(false);
  const [showBankVerificationLink, setShowBankVerificationLink] =
    useState(false);
  const [showBankVerificationUpload, setShowBankVerificationUpload] =
    useState(false);

  const [showUploadAlertModal, setShowUploadAlertModal] = useState(false);
  const [benificiaryMismatch, setBenificiaryMismatch] = useState(false);
  let [showModifyData, setShowModifyData] = useState(true);

  function clearBankVerificationUpload() {
    setFieldValue(
      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationImage",
      "",
    );
    setFieldValue(
      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationFileName",
      "",
    );
    setFieldValue(
      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationFilePath",
      "",
    );
  }

  function bankVerificationHandler(file, base64Image, fileName) {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      setBankVerificationDone(false);
      onSuccess({ content: base64Image, fileName: fileName });
    });
    return saveWidgetPromise;
  }

  function clearPennyDropDTOData() {
    var pennyDropDTO = {};
    setFieldValue("bankAccountVerificationDTO.pennyDropDTO", pennyDropDTO);
  }

  function setPennyDropDTO(
    impsTransactionInquiryOutputDTO,
    error,
    isFinancialTransaction,
  ) {
    var pennyDropDTO = {};

    if (impsTransactionInquiryOutputDTO) {
      pennyDropDTO.batchNumber = impsTransactionInquiryOutputDTO.batchNumber;
      pennyDropDTO.externalTransactionRefNo =
        impsTransactionInquiryOutputDTO.externalTransactionRefNo;
      pennyDropDTO.benefeciaryIfscCode =
        impsTransactionInquiryOutputDTO.benefeciaryIfscCode;
      pennyDropDTO.fromAccountNo =
        impsTransactionInquiryOutputDTO.fromAccountNo;
      pennyDropDTO.benefeciaryAccountNo =
        impsTransactionInquiryOutputDTO.benefeciaryAccountNo;
      pennyDropDTO.benefeciaryName =
        impsTransactionInquiryOutputDTO.benefeciaryName;
      pennyDropDTO.transactionDate =
        impsTransactionInquiryOutputDTO.transactionDate;
      pennyDropDTO.statusCode = impsTransactionInquiryOutputDTO.statusCode;
      pennyDropDTO.statusDescription =
        impsTransactionInquiryOutputDTO.statusDescription;
      if (isFinancialTransaction) {
        pennyDropDTO.bankTransferredAmount =
          impsTransactionInquiryOutputDTO.transactionAmount;
      }
      pennyDropDTO.percentageMismatchOfBeneName =
        impsTransactionInquiryOutputDTO.percentageMismatchOfBeneName;
      pennyDropDTO.beneNameFromBank =
        impsTransactionInquiryOutputDTO.benefeciaryName;
      pennyDropDTO.registeredFullName =
        impsTransactionInquiryOutputDTO.registeredFullName;
    }

    setFieldValue("bankAccountVerificationDTO.pennyDropDTO", pennyDropDTO);

    if (error) {
      setFieldValue(
        "bankAccountVerificationDTO.pennyDropDTO.errorMessage",
        error,
      );
    }

    return pennyDropDTO;
  }

  function verifyAmount(e) {
    e.preventDefault();
    e.stopPropagation();

    if (
      values.bankAccountVerificationDTO.pennyDropDTO.bankTransferredAmount !=
        null &&
      values.bankAccountVerificationDTO.pennyDropDTO.inputTransferredAmount !=
        null &&
      parseFloat(
        values.bankAccountVerificationDTO.pennyDropDTO.bankTransferredAmount,
      ).toFixed(2) ==
        parseFloat(
          values.bankAccountVerificationDTO.pennyDropDTO.inputTransferredAmount,
        ).toFixed(2)
    ) {
      setBankVerificationDone(true);
      setTransferAmountRequired(false);
      setFieldValue("bankAccountVerificationDTO.pennyDropDTO.errorMessage", "");
      values.bankAccountVerificationDTO.pennyDropDTO.errorMessage = "";
    } else {
      setBankVerificationDone(false, false);
      setFieldValue(
        "bankAccountVerificationDTO.pennyDropDTO.errorMessage",
        t("bankdetails.amountDoesntMatch"),
      );
    }
  }

  function setBankVerificationDone(isVerified, isShowBankVerificationLink) {
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.status",
      isVerified,
    );

    setFieldValue(
      "bankAccountVerificationDTO.pennyDropDTO.isVerified",
      isVerified,
    );

    if (showBankVerificationUpload) {
      setShowBankVerificationLink(false);
    } else {
      setShowBankVerificationLink(!isVerified);
    }

    if (isShowBankVerificationLink) {
      setShowBankVerificationLink(false);
    }
  }

  function onFinancialBankError(result) {
    if (result && result.errorDescription) {
      setFieldValue(
        "bankAccountVerificationDTO.pennyDropDTO.bankVerificationErrorMessage",
        result.errorDescription,
      );
    }

    setClickVerifyBank(false);
    setBankVerificationDone(false);
    setShowBankVerificationUpload(true);
    setShowUploadAlertModal(true);
    setShowBankVerificationLink(false);
  }

  function performImpsFinancialTransaction(bankVerificationInputDTO) {
    performFinancialTransaction(bankVerificationInputDTO).then(
      (res) => {
        // commented because penny drop will follow only financial transaction without asking for amount
        // this comment will be removed later
        /* if (res != null && res != "" && res.isValid == true) {
          setPennyDropDTO(res,null,true);
          setClickVerifyBank(false);
          setTransferAmountRequired(true);
          if(res.percentageMismatchOfBeneName != null && (res.percentageMismatchOfBeneName).toFixed(2) < 70.00){
            setBenificiaryMismatch(true);
          } 
          
        } */
        if (res && res.isValid == true) {
          prepareMediumDTO(true, "", bankVerificationInputDTO);
          let pennyDropData = setPennyDropDTO(res, null, false);
          let updatedKycApplicationDetails = null;
          setShowModifyData(true);
          setClickVerifyBank(false);

          if (res.percentageMismatchOfBeneName != null && !res.nameMatched) {
            setBenificiaryMismatch(true);
          }

          if (res.percentageMismatchOfBeneName != null && !res.nameMatched) {
            setBankVerificationDone(false);
            setShowBankVerificationUpload(true);
            updatedKycApplicationDetails = getBankAccountDetailsData(
              pennyDropData,
              false,
            );
          } else {
            setBankVerificationDone(true);
            updatedKycApplicationDetails = getBankAccountDetailsData(
              pennyDropData,
              true,
            );
          }
          console.log(updatedKycApplicationDetails);
          // save the bank verification data
          props.onNext(
            updatedKycApplicationDetails,
            applicationContext.currentWidget.widgetName,
            true,
          );
        } else if (
          res &&
          res.isValid == false &&
          res.nextMedium != null &&
          res.nextMedium != ""
        ) {
          prepareMediumDTO(true, res.nextMedium, bankVerificationInputDTO);
          performImpsFinancialTransaction(bankVerificationInputDTO);
        } else {
          prepareMediumDTO(true, "", bankVerificationInputDTO);
          onFinancialBankError(res);
        }
      },
      (error) => {
        prepareMediumDTO(true, "", bankVerificationInputDTO);
        onFinancialBankError(null);
      },
    );
  }

  function prepareMediumDTO(isCurrent, medium, bankVerificationInputDTO) {
    var mediumDTO = {};
    mediumDTO.isCurrent = isCurrent;
    mediumDTO.medium = medium;
    bankVerificationInputDTO.bankAccountDetailsDTO.mediumDTO = mediumDTO;
  }

  function getBankAccountDetailsData(pennyDropData, isVerified) {
    let kycApplicationDetails = values;
    if (
      kycApplicationDetails &&
      kycApplicationDetails.bankAccountVerificationDTO &&
      kycApplicationDetails.bankAccountVerificationDTO.pennyDropDTO
    ) {
      kycApplicationDetails.bankAccountVerificationDTO.pennyDropDTO =
        pennyDropData;
      kycApplicationDetails.bankAccountVerificationDTO.pennyDropDTO.status =
        isVerified;
      kycApplicationDetails.bankAccountVerificationDTO.pennyDropDTO.isVerified =
        isVerified;
    }

    return kycApplicationDetails;
  }

  function performImpsNonFinancialTransaction(bankVerificationInputDTO) {
    performNonFinancialTransaction(bankVerificationInputDTO).then(
      (res) => {
        if (res && res.isValid == true) {
          let pennyDropData = setPennyDropDTO(res, null, true);
          setShowModifyData(false);
          setClickVerifyBank(false);
          setBankVerificationDone(true);
          if (
            res.percentageMismatchOfBeneName != null &&
            res.percentageMismatchOfBeneName.toFixed(2) < mismatchPercentage
          ) {
            setBenificiaryMismatch(true);
          }
          // save the bank verification data
          props.onNext(
            getBankAccountDetailsData(pennyDropData),
            applicationContext.currentWidget.widgetName,
            true,
          );
        } else {
          performImpsFinancialTransaction(bankVerificationInputDTO);
        }
      },
      (error) => {
        performImpsFinancialTransaction(bankVerificationInputDTO);
      },
    );
  }

  function performBankVerification(e) {
    e.stopPropagation();

    if (clickVerifyBank == false) {
      setClickVerifyBank(true);
      setBankVerificationDone(false);
      clearPennyDropDTOData();
      setTransferAmountRequired(false);
      setShowBankVerificationUpload(false);
      setIsDisabled(true);
      var bankVerificationInputDTO = {};
      bankVerificationInputDTO.bankAccountDetailsDTO =
        values.bankAccountVerificationDTO.bankAccountDetailsDTO;
      bankVerificationInputDTO.holderType =
        applicationContext.currentHolder.entityTypeName;
      bankVerificationInputDTO.sessionToken = sessionStorage.getItem(
        SessionKeyEnum.AppKey,
      );

      // perform non financial transaction
      //performImpsNonFinancialTransaction(bankVerificationInputDTO);
      performImpsFinancialTransaction(bankVerificationInputDTO);
    }
  }

  function performBankVerificationFinancial(e) {
    e.stopPropagation();

    if (clickVerifyBank == false) {
      setClickVerifyBank(true);
      setBankVerificationDone(false);
      clearPennyDropDTOData();
      setTransferAmountRequired(false);
      setShowBankVerificationUpload(false);
      setIsDisabled(true);
      var bankVerificationInputDTO = {};
      bankVerificationInputDTO.bankAccountDetailsDTO =
        values.bankAccountVerificationDTO.bankAccountDetailsDTO;
      bankVerificationInputDTO.holderType =
        applicationContext.currentHolder.entityTypeName;
      bankVerificationInputDTO.sessionToken = sessionStorage.getItem(
        SessionKeyEnum.AppKey,
      );

      // perform non financial transaction
      //performImpsNonFinancialTransaction(bankVerificationInputDTO);
      performImpsFinancialTransaction(bankVerificationInputDTO);
    }
  }

  // on clicking enable fields
  function enableFields(e) {
    validateBankVerification().then(
      (res) => {
        if (res) {
          e.preventDefault();

          // show IFSC lookup after clearing the controls
          if (
            values &&
            values.bankAccountVerificationDTO &&
            values.bankAccountVerificationDTO.bankAccountDetailsDTO &&
            values.bankAccountVerificationDTO.bankAccountDetailsDTO.ifscBranch
          ) {
            setShowIfscLookup(true);
          } else {
            //do nothing
          }

          // enable the fields
          setIsDisabled(false);
          // clear the data
          clearPennyDropDTOData();
          //hide bank verification upload
          setShowBankVerificationUpload(false);
          // clear the uploaded data
          clearBankVerificationUpload();
          // show the bank verification link
          setShowBankVerificationLink(true);
          // set bank has not been verified
          setFieldValue(
            "bankAccountVerificationDTO.bankAccountDetailsDTO.status",
            false,
          );
          // set the ben mismatch
          setBenificiaryMismatch(false);
          // amount transferred remove
          setTransferAmountRequired(false);
        }
      },
      (error) => {
        //onFinancialBankError(error);
      },
    );
  }

  function displayBankVerification() {
    if (
      values.bankAccountVerificationDTO.bankAccountDetailsDTO &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.bankName &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.branch &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.name &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.active &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.accountNumber &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.accountType &&
      values.bankAccountVerificationDTO.bankAccountDetailsDTO.ifscBranch &&
      (values.bankAccountVerificationDTO.pennyDropDTO == null ||
        (values.bankAccountVerificationDTO.pennyDropDTO &&
          (values.bankAccountVerificationDTO.pennyDropDTO
            .bankVerificationFileName == null ||
            values.bankAccountVerificationDTO.pennyDropDTO
              .bankVerificationFileName == "") &&
          (values.bankAccountVerificationDTO.pennyDropDTO.isVerified == null ||
            values.bankAccountVerificationDTO.pennyDropDTO.isVerified ==
              undefined)))
    ) {
      setShowBankVerificationLink(true);
    } else {
      setShowBankVerificationLink(false);
    }

    if (transferAmountRequired || showBankVerificationUpload) {
      setShowBankVerificationLink(false);
    }

    /* if(values.bankAccountVerificationDTO.pennyDropDTO &&
      ((values.bankAccountVerificationDTO.pennyDropDTO.isVerified == null || 
        values.bankAccountVerificationDTO.pennyDropDTO.isVerified == undefined) || 
          (values.bankAccountVerificationDTO.pennyDropDTO.isVerified === false)) &&
        values.bankAccountVerificationDTO.pennyDropDTO.bankTransferredAmount &&
        parseFloat(values.bankAccountVerificationDTO.pennyDropDTO.bankTransferredAmount).toFixed(2) > 0.00){
          setTransferAmountRequired(true);
          setShowBankVerificationUpload(false);
          setIsDisabled(true);
          
    } */
  }

  useEffect(() => {
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.name",
      applicationContext.currentHolder.registrationName,
    );
    // if the bank verification is done through imps
    if (
      values &&
      values.bankAccountVerificationDTO &&
      values.bankAccountVerificationDTO.pennyDropDTO &&
      values.bankAccountVerificationDTO.pennyDropDTO.isVerified
    ) {
      setIsDisabled(true);
      setShowBankVerificationLink(true);
      setShowBankVerificationUpload(false);
    } else if (
      values &&
      values.bankAccountVerificationDTO &&
      values.bankAccountVerificationDTO.pennyDropDTO &&
      (values.bankAccountVerificationDTO.pennyDropDTO.isVerified == false ||
        values.bankAccountVerificationDTO.pennyDropDTO.bankVerificationFileName)
    ) {
      setIsDisabled(true);
      setShowBankVerificationLink(false);
      setShowBankVerificationUpload(true);
    }
    if (applicationContext.currentWidget.status !== "Completed") {
      setdefaultAccountType();
    }

    getLookupData("kycSetting", "MaximumAllowedBankNameMatchPercentage").then(
      (res) => {
        setMismatchPercentage(res["MaximumAllowedBankNameMatchPercentage"]);

        if (
          values &&
          values.bankAccountVerificationDTO &&
          values.bankAccountVerificationDTO.pennyDropDTO &&
          values.bankAccountVerificationDTO.pennyDropDTO
            .percentageMismatchOfBeneName != null &&
          values.bankAccountVerificationDTO.pennyDropDTO
            .percentageMismatchOfBeneName != undefined &&
          values.bankAccountVerificationDTO.pennyDropDTO.percentageMismatchOfBeneName.toFixed(
            2,
          ) < res["MaximumAllowedBankNameMatchPercentage"]
        ) {
          setBenificiaryMismatch(true);
        }
      },
      (error) => {},
    );
  }, []);

  useEffect(() => {
    // set if bank verification can be displayed
    displayBankVerification();
  }, [values.bankAccountVerificationDTO.bankAccountDetailsDTO]);

  useEffect(() => {
    // set if bank verification can be displayed
    displayBankVerification();
  }, [
    values.bankAccountVerificationDTO.pennyDropDTO,
    transferAmountRequired,
    showBankVerificationUpload,
  ]);

  function handleBankChange(value) {
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscBranch",
      null,
    );
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.branch",
      null,
    );
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode",
      null,
    );
    if (value === null || value === undefined || value === "") {
      setBankId(null);
    }
  }
  function handleCityChange() {
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscBranch",
      null,
    );
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.branch",
      null,
    );
    setFieldValue(
      "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode",
      null,
    );
  }

  function handleIFSCBranchChange(value) {
    if (value != null && value != undefined && value != "") {
      setFieldValue(
        "bankAccountVerificationDTO.bankAccountDetailsDTO.branch",
        value.branchName,
      );
      setFieldValue(
        "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode",
        value.ifscCode,
      );
    } else {
      setFieldValue(
        "bankAccountVerificationDTO.bankAccountDetailsDTO.branch",
        null,
      );
      setFieldValue(
        "bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode",
        null,
      );
    }
  }

  //default account type
  // function setdefaultAccountType() {
  //   getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
  //     (res) => {
  //       setFieldValue(
  //         "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
  //         res
  //       );
  //     },
  //     (error) => {}
  //   );
  // }

  // function setdefaultAccountType() {
  //   getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
  //     (res) => {
  //       if (
  //         values.personalInfoDTO.taxDeclarationDTO.residentOfIndia ===
  //         "Resident"
  //       ) {
  //         setFieldValue(
  //           "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
  //           res
  //         );
  //       } else {
  //         setFieldValue(
  //           "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
  //           null
  //         );
  //       }
  //     },
  //     (error) => {}
  //   );
  // }

  // function setdefaultAccountType() {
  //   const residentStatus =
  //     values.personalInfoDTO.taxDeclarationDTO.residentOfIndia;

  //   // Choose tag value based on resident status
  //   const tagValue =
  //     residentStatus === "Resident"
  //       ? TagValueEnum.SAVINGS
  //       : TagValueEnum.NROSAVINGS; // fallback if blank
  //   if (!tagValue) return; // nothing to set

  //   getTagValue(TagEnum.ACCOUNTTYPE, tagValue).then(
  //     (res) => {
  //       if (residentStatus === "Resident") {
  //         setFieldValue(
  //           "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
  //           res
  //         );
  //       } else {
  //         setFieldValue(
  //           "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
  //           res
  //         );
  //       }
  //     },
  //     (error) => {
  //       console.error("Error fetching account type tag value:", error);
  //     }
  //   );
  // }

   function setdefaultAccountType() {
    const residentStatus =
      values?.personalInfoDTO?.taxDeclarationDTO?.residentOfIndia;

    // Choose tag value based on resident status
    const tagValue =
      residentStatus === "Resident"
        ? TagValueEnum.SAVINGS
        : TagValueEnum.NROSAVINGS; // fallback if blank
    if (!tagValue) return; // nothing to set

    getTagValue(TagEnum.ACCOUNTTYPE, tagValue).then(
      (res) => {
        setFieldValue(
          "bankAccountVerificationDTO.bankAccountDetailsDTO.accountType",
          res,
        );
      },
      (error) => {
        console.error("Error fetching account type tag value:", error);
      },
    );
  }


  function getFilterValue() {
    const resident =
      values?.personalInfoDTO?.taxDeclarationDTO?.residentOfIndia;

    if (resident === "Resident") {
      return "Resident"; // Case 1: Resident
    }

    if (!resident || resident.trim() === "") {
      return "Resident"; // Case 2: Empty → send -1
    }

    return "Non-Resident"; // Case 3: Any other value
  }

  return (
    <React.Fragment>
      <div className="content_body">
        {/* Overall width control */}
        <div className="row">
          <div className="col-lg-8 col-sm-11 col-12 mx-auto">
            <div>
              <span className={styles.file_instruction}>
                {t("bankdetails.bankHelpText1")}
              </span>
            </div>
            <div>
              <span className={styles.file_instruction}>
                {t("bankdetails.bankHelpText2")}
              </span>
            </div>
            <p>
              <span className={styles.file_instruction}>
                {t("bankdetails.bankHelpText3")}
              </span>
            </p>
            {/* One Column Approach */}
            <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
              <CsplAchField
                label={"bankdetails.bankname"}
                name="bankAccountVerificationDTO.bankAccountDetailsDTO.bankName"
                required={true}
                idColumn="id"
                lookupName="bank"
                displayColumn="name"
                disabled={isDisabled}
                id="bankname"
                getIdValue={setBankId}
                onValueChange={handleBankChange}
              ></CsplAchField>
            </div>

            {applicationContext.currentWidget.status === "Completed" &&
            !showIfscLookup &&
            (values.bankAccountVerificationDTO.bankAccountDetailsDTO
              .ifscBranch === null ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === undefined ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === "") ? (
              <></>
            ) : (
              <>
                <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
                  <CsplAchField
                    lookupName={"ifscBranch"}
                    displayColumn="ifscCode"
                    secondaryColumn="branchName"
                    idColumn="id"
                    name="bankAccountVerificationDTO.bankAccountDetailsDTO.ifscBranch"
                    required={true}
                    label={"bankdetails.ifscOrBranch"}
                    disabled={isDisabled}
                    onValueChange={handleIFSCBranchChange}
                    id="ifscBranch"
                    filterValue={bankID}
                  />
                  <div className={styles.help_text}>
                    {t("bankdetails.ifscHelpText")}
                  </div>
                </div>

                <div>
                  <span className="text-dark">
                    {" "}
                    {t("bankdetails.ifscCode")}{" "}
                  </span>
                  <span className="text-dark">
                    {" "}
                    {
                      values.bankAccountVerificationDTO.bankAccountDetailsDTO
                        .ifscCode
                    }{" "}
                  </span>
                </div>

                <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
                  <span className="text-dark">
                    {" "}
                    {t("bankdetails.branchnameHeader")}{" "}
                  </span>
                  <span className="text-dark">
                    {" "}
                    {
                      values.bankAccountVerificationDTO.bankAccountDetailsDTO
                        .branch
                    }{" "}
                  </span>
                </div>
              </>
            )}

            {applicationContext.currentWidget.status === "Completed" &&
            (values.bankAccountVerificationDTO.bankAccountDetailsDTO
              .ifscBranch === null ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === undefined ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === "") ? (
              <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="bankAccountVerificationDTO.bankAccountDetailsDTO.branch"
                  required={true}
                  label={"bankdetails.branchname"}
                  disabled={true}
                  id="bankbranch"
                ></CsplTextBoxField>
              </div>
            ) : (
              <></>
            )}
            <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="bankAccountVerificationDTO.bankAccountDetailsDTO.name"
                required={true}
                label={"bankdetails.accountHolderName"}
                disabled={true}
                id="name"
              ></CsplTextBoxField>
            </div>

            {applicationContext.currentWidget.status === "Completed" &&
            (values.bankAccountVerificationDTO.bankAccountDetailsDTO
              .ifscBranch === null ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === undefined ||
              values.bankAccountVerificationDTO.bankAccountDetailsDTO
                .ifscBranch === "") ? (
              <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode"
                  required={true}
                  label={"bankdetails.ifsc"}
                  disabled={isDisabled}
                  id="ifsc"
                ></CsplTextBoxField>
              </div>
            ) : (
              <></>
            )}
            <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="bankAccountVerificationDTO.bankAccountDetailsDTO.accountNumber"
                required={true}
                label={"bankdetails.accountnumber"}
                disabled={isDisabled}
                id="accountnumber"
              ></CsplTextBoxField>
            </div>

            <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto">
              <CsplAchField
                lookupName={"accountTypeForResidentialStatus"}
                // lookupName={"accountTypeExcludeCode"}
                displayColumn="name"
                idColumn="id"
                name="bankAccountVerificationDTO.bankAccountDetailsDTO.accountType"
                required={true}
                label={"bankdetails.accounttype"}
                disabled={isDisabled}
                id="accounttype"
                filterValue={getFilterValue()}
              ></CsplAchField>
            </div>
            {formMode != VIEW_MODE &&
              isDisabled &&
              isFormDisabled == false &&
              clickVerifyBank == false &&
              showModifyData &&
              (applicationContext.currentWidget.status === "Completed"
                ? values.bankAccountVerificationDTO.bankAccountDetailsDTO
                    .ifscBranch
                : showModifyData) && (
                <div className="col-md-11 col-sm-11 col-12 mb-4 me-auto">
                  <Button
                    className="btn shadow-none ok_btn cursor_pointer"
                    onClick={(event) => enableFields(event)}
                  >
                    {t("bankdetails.modifyData")}
                  </Button>
                </div>
              )}

            {formMode != VIEW_MODE &&
              isFormDisabled == false &&
              showBankVerificationLink && (
                <div className="col-md-6 col-sm-11 col-12 mb-4 me-auto aadhaar-xml-link d-flex flex-column">
                  <a
                    className="text-end btn shadow-none aadhaar-xml-btn p-0 mb-2 float-right"
                    onClick={(e) => performBankVerification(e)}
                  >
                    <CsplLabel label="bankdetails.performBankVerification"></CsplLabel>
                  </a>

                  <span className={styles.performBankVerification_instruction}>
                    {t("bankdetails.performBankVerificationText")}
                  </span>

                  {/* { <a
                  className=""
                  onClick={(e) => performBankVerificationFinancial(e)}
                >
                  <CsplLabel label="bankdetails.performBankVerificationFinancial"></CsplLabel>
                </a>  } */}

                  {clickVerifyBank && (
                    <CsplBackDropLoading
                      showLoading={clickVerifyBank}
                    ></CsplBackDropLoading>
                  )}
                </div>
              )}
            {transferAmountRequired && (
              <>
                <div className="col-md-11 col-sm-11 col-12 mb-2 me-auto">
                  <div className="d-flex justify-content-between">
                    <div className="w-50 me-3">
                      <CsplNumberField
                        name="bankAccountVerificationDTO.pennyDropDTO.inputTransferredAmount"
                        required={true}
                        label={"bankdetails.transactionAmount"}
                        disabled={formMode == VIEW_MODE}
                        id="transactionAmount"
                      ></CsplNumberField>
                    </div>
                    <div className="w-50">
                      <Button
                        className="btn shadow-none ok_btn cursor_pointer"
                        onClick={(event) => verifyAmount(event)}
                      >
                        {t("bankdetails.verify")}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-11 col-12 mb-2 me-auto">
                  <span className={styles.file_instruction}>
                    {t("bankdetails.enterAmountCredited")}
                  </span>
                </div>
              </>
            )}
            {formMode != VIEW_MODE &&
              values &&
              values.bankAccountVerificationDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO.errorMessage && (
                <>
                  <div className="col-sm-11 w-100 me-3 mb-4 error-message-text">
                    <CsplLabel
                      label={
                        values.bankAccountVerificationDTO.pennyDropDTO
                          .errorMessage
                      }
                    ></CsplLabel>
                  </div>
                </>
              )}

            {formMode === VIEW_MODE &&
              values &&
              values.bankAccountVerificationDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO
                .bankVerificationErrorMessage && (
                <>
                  <div className="col-sm-11 w-100 me-3 mb-4 error-message-text">
                    <span>{t("bankdetails.errorDescription")}</span>
                    <CsplLabel
                      label={
                        values.bankAccountVerificationDTO.pennyDropDTO
                          .bankVerificationErrorMessage
                      }
                    ></CsplLabel>
                  </div>
                </>
              )}

            {values.bankAccountVerificationDTO.pennyDropDTO.isVerified &&
              showBankVerificationUpload == false && (
                <div className="success-message-text mb-4 ">
                  <CsplLabel label="bankdetails.bankVerified"></CsplLabel>
                </div>
              )}
            {formMode == VIEW_MODE &&
              values &&
              values.bankAccountVerificationDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO
                .beneNameFromBank && (
                <div className="col-md-6 col-sm-11 col-12 mt-4 mb-4 me-auto">
                  <CsplTextBoxField
                    name="bankAccountVerificationDTO.pennyDropDTO.beneNameFromBank"
                    label={"bankdetails.beneficiaryNameFromBank"}
                    disabled={true}
                    id="name"
                  ></CsplTextBoxField>
                </div>
              )}

            {benificiaryMismatch && formMode != VIEW_MODE && (
              <div className="error-message-text mb-4 ">
                <CsplLabel label="bankdetails.beneficiaryMisMatch"></CsplLabel>
              </div>
            )}
            {formMode == VIEW_MODE &&
              values &&
              values.bankAccountVerificationDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO
                .externalTransactionRefNo && (
                <div className="col-md-6 col-sm-11 col-12 mt-4 mb-4 me-auto">
                  <CsplTextBoxField
                    name="bankAccountVerificationDTO.pennyDropDTO.externalTransactionRefNo"
                    label={"bankdetails.externalTransactionRefNo"}
                    disabled={true}
                    id="name"
                  ></CsplTextBoxField>
                </div>
              )}

            {/* percentageMismatchOfBeneName benificiaryMismatch */}
            {formMode == VIEW_MODE &&
              values &&
              values.bankAccountVerificationDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO &&
              values.bankAccountVerificationDTO.pennyDropDTO
                .percentageMismatchOfBeneName != null &&
              values.bankAccountVerificationDTO.pennyDropDTO
                .percentageMismatchOfBeneName != undefined && (
                <div className="col-md-10 col-sm-11 col-12 mt-4 mb-4 me-auto">
                  <PercentageComponent
                    percentText={
                      values.bankAccountVerificationDTO.pennyDropDTO
                        .percentageMismatchOfBeneName
                    }
                    percentValue={
                      values.bankAccountVerificationDTO.pennyDropDTO
                        .percentageMismatchOfBeneName
                    }
                    title={"bankdetails.beneficiaryname"}
                    ComparisonTitle={
                      values.bankAccountVerificationDTO.pennyDropDTO
                        .registeredFullName != null
                        ? "bankdetails.fullName"
                        : "bankdetails.PanOf1stHolder"
                    }
                  />
                </div>
              )}

            {showUploadAlertModal && (
              <AlertModal
                isModalOpen={showUploadAlertModal}
                setIsModalOpen={setShowUploadAlertModal}
                type={OK}
                title={"modal.alertModalTitle"}
              >
                <ul className="text-align-justify list-style-none">
                  <p>{t("bankdetails.proceedWithUpload")}</p>

                  <li className='d-flex mb-3 "padding-left-15"'>
                    <div className="sn_1  h-50"></div>
                    <div className="margin-left-4">
                      {t("bankdetails.proceedWithUploadText2")}
                    </div>
                  </li>
                  <li className='d-flex mb-3 "padding-left-15"'>
                    <div className="sn_2  h-50"></div>
                    <div className="margin-left-4">
                      {t("bankdetails.proceedWithUploadText3")}
                    </div>
                  </li>
                  <li className='d-flex mb-3 "padding-left-15"'>
                    <div className="sn_3  h-50"></div>
                    <div className="margin-left-4">
                      {t("bankdetails.proceedWithUploadText4")}
                    </div>
                  </li>
                </ul>
              </AlertModal>
            )}

            {showBankVerificationUpload && (
              <>
                <div className="col-md-10 col-sm-11 col-12 mb-4 me-auto">
                  <CsplDragDrop
                    label={"label.bankVerificationUpload"}
                    required={true}
                    disabled={isFormDisabled}
                    onFileUpload={bankVerificationHandler}
                    base64FieldName={
                      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationImage"
                    }
                    fileNameFieldName={
                      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationFileName"
                    }
                    path={
                      "bankAccountVerificationDTO.pennyDropDTO.bankVerificationFilePath"
                    }
                  ></CsplDragDrop>
                </div>
              </>
            )}

            <div className="col-sm-11 w-100 me-3 mb-4">&nbsp;</div>
            <div className="col-sm-11 w-100 me-3 mb-4 ">&nbsp;</div>
            <div className="col-sm-11 w-100 me-3 mb-4 ">&nbsp;</div>
          </div>
        </div>
      </div>

      {/*  </form> */}
    </React.Fragment>
  );
}

export default BankAccountDetails;
